module.exports = __webpack_public_path__ + "img/opinionlab-2017-plaque.27ed8a94.jpg";